import Vue from 'vue'
import Router from 'vue-router'
import Neon from '@/components/NeonView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'neonView',
      component: Neon
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js